<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch03">
<div class="chapterHead">
<h2 class="chapterTitle" style="text-indent: 0%;"><span class="bold">Enlightened</span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText" style="text-indent: 0%;">I don’t know if I can remain friends with her. I’ve thought and thought about it—she’ll never know how much. I gave it one last try. I called her, after a year. But I didn’t like the way the conversation went. The problem is that she is not very enlightened. Or I should say, she is not enlightened enough for me. She is nearly fifty years old and no more enlightened, as far as I can see, than when I first knew her twenty years ago, when we talked mainly about men. I did not mind how unenlightened she was then, maybe because I was not so enlightened myself. I believe I am more enlightened now, and certainly more enlightened than she is, although I know it’s not very enlightened to say that. But I want to say it, so I am willing to postpone being more enlightened myself so that I can still say a thing like that about a friend.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466806276_ch03.vue?5f16d763